import { Inject, Injectable, Optional } from '@angular/core';
import { CONFIG } from '../../core';
import { CryptoConfig } from '../../core/src/interfaces/config.interface';


@Injectable({
  providedIn: 'root'
})
export class CharonSessionService {

  constructor (
    @Optional() @Inject(CONFIG) private criptoCongfig: CryptoConfig) { }

  /**
   * Método que retorna as configurações de criptografia definidas no environment
   *
   * Method that returns encryption settings in the environment
   */
  get getConfigurations(): CryptoConfig {
    return this.criptoCongfig;
  }

}
